import type { Command } from 'commander';
import { registerPersonalResumesSchema } from './schema';
import { registerPersonalResumesValidate } from './validate';
import { registerPersonalResumesTemplate } from './template';
import { registerPersonalResumesList } from './list';
import { registerPersonalResumesView } from './view';
import { registerPersonalResumesExport } from './export';
import { registerPersonalResumesCreate } from './create';
import { registerPersonalResumesUpdate } from './update';
import { registerPersonalResumesCopy } from './copy';
import { registerPersonalResumesPublish, registerPersonalResumesUnpublish } from './publish';
import { registerPersonalResumesDelete } from './delete';

// Task 13 掛 list/view/export；Task 14 補 create/update；Task 15(checkpoint 3 收尾)
// 補上 copy/publish/unpublish/delete,同一份 index.ts 逐步長大。
export function registerPersonalResumesCommand(parent: Command): void {
	const resumes = parent.command('resumes').description('Manage your personal resumes');
	registerPersonalResumesSchema(resumes);
	registerPersonalResumesValidate(resumes);
	registerPersonalResumesTemplate(resumes);
	registerPersonalResumesList(resumes);
	registerPersonalResumesView(resumes);
	registerPersonalResumesExport(resumes);
	registerPersonalResumesCreate(resumes);
	registerPersonalResumesUpdate(resumes);
	registerPersonalResumesCopy(resumes);
	registerPersonalResumesPublish(resumes);
	registerPersonalResumesUnpublish(resumes);
	registerPersonalResumesDelete(resumes);
}
